import { mapActions } from 'pinia'

export default {
	data() {
		return {
			mediaQuery: null
		}
	},
    methods: {
        ...mapActions(useViewportStore, ["setIsMobileState"]),
        
		handleMediaQueryChange(event) {
			this.setIsMobileState(event.matches);
		},
	},
	mounted() {
		this.mediaQuery = window.matchMedia("(max-width: 868.98px)");

		this.setIsMobileState(this.mediaQuery.matches);

		this.mediaQuery.addEventListener("change", this.handleMediaQueryChange);
	},
    beforeUnmount() {
		if (this.mediaQuery) {
			this.mediaQuery.removeEventListener("change", this.handleMediaQueryChange);
		}
	}
}